var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-template-card" }, [
    _vm.showShare
      ? _c("div", { staticClass: "template-card__top" }, [
          _c("div", { staticClass: "template-card__icons" }, [
            _vm.item.imageEditable
              ? _c("img", {
                  staticClass: "template-card__icon",
                  attrs: {
                    src: "/assets/img/icons/gallery.svg",
                    alt: "Image editable",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.item.textEditable
              ? _c("span", { staticClass: "template-card__icon" }, [
                  _vm._v("\n                Aa\n            "),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "template-card__share" }, [
            _c(
              "button",
              { staticClass: "c-icon-button", on: { click: _vm.shareItem } },
              [
                _c("img", {
                  staticClass: "icon-button__icon",
                  attrs: { src: "/assets/img/icons/share.svg", alt: "Share" },
                }),
              ]
            ),
            _vm._v(" "),
            !_vm.isFavourite
              ? _c(
                  "button",
                  {
                    staticClass: "c-icon-button",
                    on: { click: _vm.addFavourite },
                  },
                  [
                    _c("img", {
                      staticClass: "icon-button__icon",
                      attrs: {
                        src: "/assets/img/icons/favourite.svg",
                        alt: "Add to favourites",
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFavourite
              ? _c(
                  "button",
                  {
                    staticClass: "c-icon-button",
                    on: { click: _vm.removeFavourite },
                  },
                  [
                    _c("img", {
                      staticClass: "icon-button__icon",
                      attrs: {
                        src: "/assets/img/icons/favourite-active.svg",
                        alt: "Add to favourites",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "template-card__thumbnail" }, [
      _c(
        "a",
        {
          attrs: { href: _vm.item.url, title: _vm.item.title },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.increaseQuantity.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            attrs: {
              src: _vm.item.thumbnail + "?height=215",
              alt: _vm.item.title,
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.showControls
      ? _c("div", { staticClass: "template-card__controls" }, [
          _c("div", { staticClass: "template-card-counter" }, [
            _c(
              "button",
              {
                staticClass: "template-card-counter__button",
                on: { click: _vm.decreaseQuantity },
              },
              [_vm._v("\n                -\n            ")]
            ),
            _vm._v(" "),
            _vm.showQuantity
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.quantity,
                      expression: "quantity",
                    },
                  ],
                  staticClass: "template-card-counter__input",
                  domProps: { value: _vm.quantity },
                  on: {
                    change: _vm.changeQuantity,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.quantity = $event.target.value
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "template-card-counter__button",
                on: { click: _vm.increaseQuantity },
              },
              [_vm._v("\n                +\n            ")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }